import { publicAssets } from '@/assets/public-assets';
import useAuthContext from '@/features/auth/_shared/contexts/auth.context';
import React, { memo, useEffect, useState } from 'react';

const SPLASH_SCREEN_DELAY = 800;

interface ISplashScreenProps {
  children: React.ReactNode;
}
const SplashScreen = memo(({ children }: ISplashScreenProps) => {
  const { isAuthenticated, hydrated, state } = useAuthContext();
  const [isLoadingSplashScreen, setIsLoadingSplashScreen] = useState(true);

  useEffect(() => {
    if (isAuthenticated) {
      const timer = setTimeout(() => {
        setIsLoadingSplashScreen(false);
      }, SPLASH_SCREEN_DELAY);

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated]);

  if (isAuthenticated && (isLoadingSplashScreen || !hydrated || state?.loading)) {
    return (
      <div className="fixed inset-0 bg-[#0C8DBF] flex items-center justify-center">
        <div>
          <img src={publicAssets.NOLIMIT_LOGO} alt="NoLimit Logo" className="w-[100px] h-[100px]  object-contain" />
        </div>
      </div>
    );
  }

  return <>{children}</>;
});

SplashScreen.displayName = 'SplashScreen';

export default SplashScreen;
